import { useMemo } from 'react';
import useFriends from '@/hooks/contacts/use-friends';
import useGroupMembers from '@/hooks/groups/use-group-members';
import useFuseSearch from '@/hooks/search/use-fuse-search';
import type { GroupMember } from '@/models/group/group-info';

export type SearchGroupMember = GroupMember & { RemarkName: string };

export default function useSearchGroupMembers(groupId: Nullable<number>, keyword: string) {
  const { friends } = useFriends();
  const { members } = useGroupMembers(groupId);

  const membersWithRemarkName = useMemo(() => {
    const memberList = Object.values(members);
    if (!memberList.length) return [];

    return memberList.map((member) => {
      const friend = friends[member.UserID];

      return {
        ...member,
        RemarkName: friend?.RemarkName ?? '',
      };
    }, []);
  }, [members, friends]);

  return useFuseSearch<SearchGroupMember>({
    data: membersWithRemarkName,
    keyword,
    keys: ['RemarkName', 'GroupMemberName', 'UserNickName'],
    initialReturnAll: true,
  });
}
